export default {
  cardIcon (val) {
    switch (val) {
      case 'Visa': return 'visa'
      case 'Master Card': return 'mastercard'
      case 'MasterCard': return 'mastercard'
      case 'mastercard': return 'mastercard'
      case 'American Express': return 'amex'
      case 'Discover': return 'discover'
      case 'JCB': return 'jcb'
      case 'Diners Club': return 'diners'
      default: return 'unknown'
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/payment.js